import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { ASSET_QUERY_KEYS } from './keys';

import { fetchAssetsById } from 'services/assets';

interface AssetItem {
  id: string;
  [key: string]: string | number | boolean | null | undefined;
}

export const useFetchAssetsById = (id: string | number): UseQueryResult<AssetItem[], Error> => {
  return useQuery<AssetItem[], Error>({
    queryKey: [ASSET_QUERY_KEYS.ASSETS_BY_ID, id],
    queryFn: () => fetchAssetsById(id) as Promise<AssetItem[]>,
  });
};
